// crewbit-admin/src/components/money/QuickMethodNudgeBanner.tsx
//
// Page-level upsell banner. Visibility per Decision §Tax.D2 + §3c LOCKED:
//   tax_mode === 'charge'  →  show
//   anything else          →  hidden
//
// Full eligibility (revenue threshold + business age) deferred per
// §Tax.QuickMethodEligibilityServerSide. Server-side gate flag will plug
// in here when shipped.
//
// Click routes to /settings/tax (legacy admin Settings TaxCompliance page).
// Will swap to /money/settings/taxes when §Settings hub admin UI ships
// (Session 139 — Tier 1).
//
// Spec §Tax.7.2 + §Tax.D2.

import { Sparkles, ChevronRight } from 'lucide-react';
import { palette, admin, radii, spacing, transition } from '../../styles/tokens';

interface QuickMethodNudgeBannerProps {
  taxMode: 'charge' | 'exempt' | 'quick_method';
  onClick: () => void;
}

export function QuickMethodNudgeBanner({ taxMode, onClick }: QuickMethodNudgeBannerProps) {
  if (taxMode !== 'charge') return null;

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: spacing.md,
        width: '100%',
        padding: `${spacing.sm + 2}px ${spacing.md}px`,
        background: palette.purpleWash,
        border: `1px solid ${palette.purple}`,
        borderRadius: admin.cardRadius,
        marginBottom: spacing.md,
        cursor: 'pointer',
        textAlign: 'left',
        fontFamily: 'inherit',
        transition: `background ${transition.fast}`,
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: radii.sm,
          background: palette.white,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Sparkles size={16} color={palette.purple} strokeWidth={2} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: palette.purple }}>
          You may qualify for the Quick Method
        </div>
        <div style={{ fontSize: 12, color: palette.purple, marginTop: 2, opacity: 0.85 }}>
          Many service businesses save by using a flat HST remittance rate. Tap to review.
        </div>
      </div>
      <ChevronRight size={18} color={palette.purple} strokeWidth={2.25} />
    </button>
  );
}
